import IndexLayout from '~/src/layouts/index-layout';
import * as React from 'react';
export default {
  IndexLayout,
  React
};